import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from '../api/tenant.service';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';
import { RouterSegments } from 'src/app/models/router-segments';


@Injectable({
  providedIn: 'root'
})
export class ExternalTenantGuard implements CanActivate {

  constructor(
    private tenantService: TenantService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const segments = state.url.split('/').filter(Boolean);
    const tenant = segments[2];
    if (!tenant) {
      return of(this.router.createUrlTree(['/']));
    }

    return this.tenantService.getTenants(tenant).pipe(
      map((response: any) => {
        const tenantData = response;
        this.tenantService.setTenant(tenant);
        if (tenantData?.[0]?.origin === TenantOrigin.EXTERNAL) {
          this.router.navigate(
            [
              '/',
              tenant,
              RouterSegments.TENANT,
              'permission-unauthorized'
            ],
            { skipLocationChange: true }
          );
        }
        return true;
      })
    );
  }
}